var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default"},[_c('div',[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("@/assets/default/vcy_pic_404.png")}})]),_c('div',{staticClass:"message"},[_c('div',{staticClass:"title"},[_vm._v("当前页面不存在")]),_c('div',{staticClass:"tip"},[_vm._v("404")])])])])
}]

export { render, staticRenderFns }